import { BackgroundTask, BackgroundTaskResult } from './ValidationBackgroundProcessing';
import documentValidationSteps from '../validationSteps';
import Result from '../../../common/result';
import { Authentication } from '../../../services/faceAuthentication';

export default class CompleteUniquenessTask implements BackgroundTask {
  private validationId: string;

  private uniquenessResult: Authentication;

  constructor(validationId: string, uniquenessResult: Authentication) {
    this.validationId = validationId;
    this.uniquenessResult = uniquenessResult;
  }

  async runBackgroundTask(): Promise<BackgroundTaskResult> {
    const uploadUniqunessResult = await documentValidationSteps.uploadUniquenessResultStep(
      this.validationId,
      this.uniquenessResult,
    );
    if (uploadUniqunessResult.isFailed()) {
      return Result.noValueFailed(uploadUniqunessResult.failure());
    }

    return Result.noValueSuccess();
  }
}
